<template>
    <div>
        <div class="main-title no-filters"><h1 class="main">{{t('import_contacts_page.title_2nd_phase')}}</h1>
            <div class="action-buttons">
                <button @click="startImport()" class="neutral-button" :disabled="!enableImportButton">
                    {{t('import_contacts_page.action_continue_import')}}
                </button>
                <button @click="cancelImport()" class="gray-button">{{t('import_contacts_page.action_cancel_import')}}
                </button>
            </div>
        </div>
        <div class="import-information-table">
            <div class="import-information-inner">
                <div v-if="showMergeSettings" class="import-information-col" id="settings-area">
                    <div class="import-settings-table-wrapper">
                        <table>
                            <thead>
                            <tr>
                                <th colspan="4"><h3>{{t('import_contacts_page.settings_title')}}</h3></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th>{{t('import_contacts_page.settings_field')}}</th>
                                <th>{{t('import_contacts_page.settings_add')}}</th>
                                <th>{{t('import_contacts_page.settings_update')}}</th>
                                <th>{{t('import_contacts_page.settings_delete')}}</th>
                            </tr>
                            <field-settings v-for="field in columns"
                                            :data="duplicateFieldSettingsValue[field.name]"
                                            :field="field"
                                            :key="field.name"
                                            v-on:update="updateDuplicateFieldSettings"/>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="import-information-col">
                    <table class="import-status-table">
                        <thead>
                        <tr>
                            <th></th>
                            <th>{{t('import_contacts_page.status_errors')}}</th>
                            <th>{{t('import_contacts_page.status_duplicates')}}</th>
                            <th>{{t('import_contacts_page.status_new')}}</th>
                            <th>{{t('import_contacts_page.status_total')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th>{{t('import_contacts_page.status_pending')}}</th>
                            <td id="status-pending-errors">{{splitDataToTabs.errors.length}}</td>
                            <td id="status-pending-duplicates">{{splitDataToTabs.duplicates.length}}</td>
                            <td id="status-pending-new">{{splitDataToTabs.new.length}}</td>
                            <td id="status-pending-total">{{importData ? importData.length : 0}}</td>
                        </tr>
                        <tr>
                            <th>{{t('import_contacts_page.status_selected')}}</th>
                            <td id="status-selected-errors">-</td>
                            <td id="status-selected-duplicates">{{selectedDuplicatesCount}}</td>
                            <td id="status-selected-new">{{splitDataToTabs.new.length}}</td>
                            <td id="status-selected-total">{{splitDataToTabs.new.length + selectedDuplicatesCount}}</td>
                        </tr>
                        <tr>
                            <th>{{t('import_contacts_page.status_imported')}}</th>
                            <td id="status-imported-errors">-</td>
                            <td id="status-imported-duplicates">{{importedDuplicatesCount}}</td>
                            <td id="status-imported-new">{{importedNewCount}}</td>
                            <td id="status-imported-total">{{importedTotalCount}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="sub-tabs">
            <div v-for="(tab, index) in tabs"
                 class="sub-tab"
                 :class="tabHeadersClass[index]"
                 v-if="tab !== 'importedDuplicates' || importedDuplicates.length"
                 @click="activeTab=tab"
            >{{t(`import_contacts_page.tab_${tab}`)}}
                <sup>{{splitDataToTabs[tab].length}}</sup>
            </div>
        </div>

        <div class="sub-tab-areas">
            <div v-for="(tab, index) in tabs"
                 class="sub-tab-area"
                 v-if="activeTab === tab"
            >
                <DGTableWrapper class="table-wrapper"
                                style="height: 250px"
                                :ref="'dgtableWrapper_' + tab"
                                :cell-formatter="activeTableCellFormatter"
                                :columns="activeTableColumnsDef"
                                :on-header-context-menu="activeTableOnHeaderContextMenu"
                                :on-row-create="activeTableOnRowCreate"
                                :on-header-row-create="activeTableOnHeaderRowCreate"
                                :rows="activeTableData"/>
            </div>
        </div>

        <div data-name="import-progress-wrapper" v-if="!!progressStatusText">
            <div class="import-progress-bar">{{progressStatusText}}</div>
        </div>
    </div>

</template>

<script>

    import FieldSettings from '../components/FieldSettings.vue';
    import DGTableWrapper from '../components/DGTableWrapper.vue';
    import CustomFields from '../../../../../shared_utils/CustomFields.js';
    import i18n, { t } from '../../../../i18n/i18n.js';
    import $ from 'jquery';

    export default {
        name: "ContactImportProcess",
        components: {FieldSettings, DGTableWrapper},
        props: ['importData', 'contactCustomFields', 'progressStatusText', 'duplicateFieldSettings', 'importedDuplicates'],
        data() {
            return {
                activeTab: 'new',
                tabs: ['errors', 'duplicates', 'new', 'imported', 'importedDuplicates'],
                tabsData: {
                    errors: [],
                    duplicates: [],
                    new: [],
                    imported: [],
                    importedDuplicates: this.importedDuplicates,
                },
                selectedDuplicatesCount: 0,
            };
        },

        methods: {
            cancelImport() {
                this.$emit('cancel');
            },

            startImport() {
                this.$emit('startImport');
            },

            activateRelevantTab() {
                this.activeTab = Object.keys(this.splitDataToTabs)
                    .find(tab => this.splitDataToTabs[tab].length > 0) || this.activeTab;
            },

            updateDuplicateFieldSettings(field, type, value) {
                let settings = this.duplicateFieldSettingsValue;
                settings[field.name][type] = value;
                this.duplicateFieldSettingsValue = {...settings};
            },
        },

        computed: {
            duplicateFieldSettingsValue: {
                get() {
                    return this.duplicateFieldSettings;
                },

                set(v) {
                    this.$emit('update:duplicateFieldSettings', v);
                },
            },

            columns() {
                if (!this.importData || this.importData.length === 0)
                    return [];

                const keys = Object.keys(this.importData[0].columns);

                return keys.map(fieldKey => {
                    let fieldName = t(`contact_fields.${fieldKey}`);

                    const fieldObject = {
                        name: fieldKey,
                        label: fieldName,
                    };

                    if (this.phoneFieldsSet.has(fieldKey)) {
                        fieldObject.cellClasses = 'ltr';
                    }

                    if (!fieldName && this.contactCustomFields.length > 0) {
                        const {name} = this.contactCustomFields
                            .find(customField => `f${customField.id}` === fieldKey);
                        fieldObject.label = name;
                    }

                    return fieldObject;
                });
            },

            showMergeSettings() {
                return this.tabsData.duplicates.length > 0 || this.importData.find(c => c.id);
            },

            tabHeadersClass() {
                return this.tabs.map(tab =>
                    `import-tab-${tab} ${this.activeTab === tab ? 'selected' : ''}`);
            },

            enableImportButton() {
                return this.tabsData.new.length > 0 || this.selectedDuplicatesCount > 0;
            },

            splitDataToTabs() {
                let tabsData = {
                    errors: [],
                    duplicates: [],
                    new: [],
                    imported: [],
                    importedDuplicates: this.importedDuplicates,
                };

                for (const contact of this.importData) {
                    if (contact.result === 'ok') {
                        tabsData.imported.push(contact);
                    } else if (contact.result === 'duplicate') {
                        tabsData.duplicates.push(contact);
                    } else if (contact.result === 'error') {
                        tabsData.errors.push(contact);
                    } else {
                        tabsData.new.push(contact);
                    }
                }

                this.selectedDuplicatesCount = tabsData.duplicates.reduce((p, c) => p + (c.columns.selected ? 1 : 0), 0);

                this.tabsData = tabsData;

                if (this.importData.length > 0 && tabsData.duplicates.length === 0 && tabsData.new.length === 0) {
                    this.$emit('importCompleted', tabsData.imported.length);
                }

                return this.tabsData;
            },

            activeTableCellFormatter() {
                const tab = this.activeTab;

                return (val, colName, row) => {
                    if (colName === 'SEL') {
                        return '';
                    } else if (this.phoneFieldsSet.has(colName)) {
                        return PhoneNumberUtil.displayPhoneNumber(val || '');
                    } else if (this.dateFieldsSet.has(colName)) {
                        return val ? i18n.formatDate(val, t('date_formats.normal_date')) : '';
                    } else if (colName === 'errors') {
                        return (val || []).map(err => t('import_contacts_page.error_tab_reasons.' + err.type)).join(', ');
                    }

                    return val;
                };
            },

            activeTableColumnsDef() {
                const tab = this.activeTab;

                let columns = this.columns.map(col => {
                    return {
                        dataPath: ['columns', col.name],
                        ...col,
                        sortable: true,
                        searchable: true,
                    };
                });

                if (tab === 'duplicates') {
                    columns.unshift({
                        name: 'SEL',
                        label: t('import_contacts_page.tab_action_select'),
                        width: 50,
                        sortable: true,
                        comparePath: ['selected'],
                    });
                } else if (tab === 'errors') {
                    columns.push({
                        name: 'errors',
                        label: t('import_contacts_page.tab_errors_column'),
                        width: 100,
                        sortable: true,
                        cellClasses: 'alert',
                    });
                }

                return columns;
            },

            activeTableOnHeaderContextMenu() {
                const tab = this.activeTab;

                return (col) => {
                    // Do we want a context menu?
                };
            },

            activeTableOnRowCreate() {
                const tab = this.activeTab;

                return (physicalIndex, index, row, rowData) => {
                    let checkbox = document.createElement('input');
                    checkbox.type = 'checkbox';
                    checkbox.checked = !!rowData.selected;
                    checkbox.addEventListener('change', () => {
                        if (!!rowData.selected !== !!checkbox.checked) {
                            rowData.selected = checkbox.checked;

                            if (rowData.selected)
                                this.selectedDuplicatesCount++;
                            else
                                this.selectedDuplicatesCount--;
                        }

                        if (!rowData.selected) {
                            this.$refs['dgtableWrapper_' + tab][0]._selectAllCheckbox.checked = false;
                        }
                    });

                    $('>div[data-column=SEL]>div', row).append(checkbox);

                    if (rowData.duplicates && rowData.errors) {
                        for (const err of rowData.errors) {
                            if (err.type !== 'duplicate') continue;

                            $(row).find(`.dgtable-cell[data-column=${err.field}]`).addClass('alert');
                        }
                    }
                };
            },

            activeTableOnHeaderRowCreate() {
                const tab = this.activeTab;

                return (row) => {
                    if (tab === 'duplicates') {
                        let checkbox = document.createElement('input');
                        checkbox.type = 'checkbox';
                        checkbox.addEventListener('change', () => {
                            this.selectedDuplicatesCount = this.activeTableData.length;

                            for (let row of this.activeTableData) {
                                row.selected = checkbox.checked;
                            }

                            this.$refs['dgtableWrapper_' + tab][0].refreshRows();
                        });
                        checkbox.addEventListener('click', evt => {
                            evt.stopPropagation();
                        });

                        $('>div[data-column=SEL]>div', row)
                            .prepend(document.createTextNode(' '))
                            .prepend(checkbox);

                        this.$refs['dgtableWrapper_' + tab][0]._selectAllCheckbox = checkbox;
                    }
                };
            },

            activeTableData() {
                const tab = this.activeTab;

                switch (tab) {
                    case 'new':
                        return this.splitDataToTabs.new;

                    case 'imported':
                        return this.splitDataToTabs.imported;

                    case 'errors':
                        return this.splitDataToTabs.errors;

                    case 'duplicates':
                        return this.splitDataToTabs.duplicates;

                    case 'importedDuplicates':
                        return this.importedDuplicates;

                }
            },

            importedDuplicatesCount() {
                return this.splitDataToTabs.imported.reduce((p, c) => p + (c.originalResult === 'duplicate' ? 1 : 0), 0);
            },

            importedNewCount() {
                return this.importedTotalCount - this.importedDuplicatesCount;
            },

            importedTotalCount() {
                return this.splitDataToTabs.imported.length;
            },

            dateFieldsSet() {
                let dateFields = new Set(['birthdate']);

                if (this.contactCustomFields) {
                    for (const field of this.contactCustomFields) {
                        if (field['subtype'] === CustomFields.SubType.date) {
                            dateFields.add('f' + field['id']);
                        }
                    }
                }

                return dateFields;
            },

            phoneFieldsSet() {
                let phoneFields = new Set(['phone', 'phone2', 'phone3', 'phone4', 'fax']);

                if (this.contactCustomFields) {
                    for (const field of this.contactCustomFields) {
                        if (field['subtype'] === CustomFields.SubType.tel) {
                            phoneFields.add('f' + field['id']);
                        }
                    }
                }

                return phoneFields;
            },

            emailFieldsSet() {
                return new Set(['email']);
            },
        },

        mounted() {
            this.activateRelevantTab();
        },
    };
</script>
